import { FieldBase } from './field-base';

export class TextareaQuestion extends FieldBase<string> {

    constructor(options: {} = {}) {
        super(options);
    }
}